
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/_work/back-office/back-office/apps/back-office/sentry.client.config.ts")
            }
          });